module.exports = __webpack_public_path__ + "static/media/oxygen7-logo.9f3b12f5.png";